import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { updateTeamMemberData } from "~/providers/api";

export const useUpdateTeamMemberDetails = () => {
  return useMutation({
    mutationFn: updateTeamMemberData,
    onError: () =>
      toast.error(
        "There was an issue updating your information. Please try again later.",
      ),
  });
};
